/**
 * Text with Icons - Tooltip functionality
 * Initializes tooltip modals for a given section
 */
function initTextWithIconsTooltip(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  const overlay = section.querySelector('[data-tooltip-overlay]');
  let activeModal = null;
  let activeTrigger = null;

  // Position modal relative to trigger
  function positionModal(trigger, modal) {
    const triggerRect = trigger.getBoundingClientRect();
    const modalRect = modal.getBoundingClientRect();
    
    // Position so bottom-right of modal is above the trigger with enough gap to see tooltip
    let top = triggerRect.top - modalRect.height - 24;
    let left = triggerRect.right - modalRect.width;
    
    // Ensure modal doesn't go off-screen left
    if (left < 8) {
      left = 8;
    }
    
    // Ensure modal doesn't go off-screen right
    if (left + modalRect.width > window.innerWidth - 8) {
      left = window.innerWidth - modalRect.width - 8;
    }
    
    // If modal would go above viewport, show below trigger
    if (top < 8) {
      top = triggerRect.bottom + 24;
    }
    
    modal.style.top = top + 'px';
    modal.style.left = left + 'px';
  }

  // Update position on scroll
  function updatePosition() {
    if (activeModal && activeTrigger) {
      positionModal(activeTrigger, activeModal);
    }
  }

  // Close active tooltip
  function closeActiveTooltip() {
    if (activeModal) {
      activeModal.classList.remove('is-open');
      activeModal = null;
      activeTrigger = null;
      window.removeEventListener('scroll', updatePosition);
    }
    if (overlay) {
      overlay.classList.remove('is-open');
    }
  }

  // Open tooltip modal
  section.querySelectorAll('[data-tooltip-open]').forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const id = this.getAttribute('data-tooltip-open');
      const modal = section.querySelector('[data-tooltip-modal="' + id + '"]');
      
      // If clicking the same tooltip, close it
      if (modal && modal === activeModal) {
        closeActiveTooltip();
        return;
      }
      
      // Close any existing tooltip first
      closeActiveTooltip();
      
      if (modal && overlay) {
        // Show modal first to get its dimensions
        modal.style.visibility = 'hidden';
        modal.classList.add('is-open');
        
        // Position the modal
        positionModal(this, modal);
        
        // Now make it visible
        modal.style.visibility = '';
        overlay.classList.add('is-open');
        activeModal = modal;
        activeTrigger = this;
        
        // Update position on scroll
        window.addEventListener('scroll', updatePosition, { passive: true });
      }
    });
  });

  // Close tooltip modal via close button
  section.querySelectorAll('[data-tooltip-close]').forEach(function(closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeActiveTooltip();
    });
  });

  // Close tooltip modal via overlay click
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      closeActiveTooltip();
    });
  }

  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeActiveTooltip();
    }
  });
}
